import type { ThemeFit } from '../../../tailor'

/**
 * Juta (footwear-1): how the inherited section schemas fit this theme's own section designs. `hide` lists the
 * fields its components never draw, so the editor only offers what changes the page (stored values are kept);
 * `keep` / `add` / `variantLabels` list the layouts its components draw, by name. Checked by
 * tests/section-contract.test.ts in storefront-nuxt.
 */
export const footwear1Fit: ThemeFit = {
  'account': { hide: ['signinRedirectPath'] },
  'announcement-bar': { hide: ['bgColor', 'textColor'] },
  'cart': { hide: ['loadingText', 'taxLabel', 'secureCheckoutText'] },
  'category': { hide: ['productCardVariant', 'initialPriceRange', 'showBreadcrumb'] },
  'checkout': { hide: ['loadingText', 'shippingCalculatingText', 'securePaymentText'] },
  'cta': { hide: ['bgColor'] },
  'featured-category': { hide: ['productCardVariant', 'noSelectionText', 'noProductsText'] },
  'features': { hide: ['bgStyle'] },
  'hero': { variantLabels: { v1: 'Full-bleed photo', v2: 'Split', v3: 'Poster', v4: 'Charcoal' } },
  'flash-sale': { hide: ['bgColor', 'products'] },
  'new-arrivals': { hide: ['products'] },
  'order-success': { hide: ['loadingText'] },
  'product-detail': { hide: ['loadingText', 'notFoundCode', 'notFoundText'], keep: ['v1', 'v2', 'v3', 'v6'], variantLabels: { v1: 'Standard', v2: 'Sale countdown band', v3: 'Large photo swatches', v6: 'Video under the photo' } },
  'shop-grid': { hide: ['productCardVariant', 'initialPriceRange', 'sortOldestLabel', 'sortNameDescLabel'] },
  'similar-products': { hide: ['productCardVariant'] },
  'blog': { keep: ['v1', 'v2'] },
  'banner-carousel': { variantLabels: { v1: 'Full-bleed slides', v2: 'Poster row' } },
  'banner': { variantLabels: { v1: 'Selling points strip', v2: 'Wide', v3: 'Square picture tiles' } },
  'product-slider': { variantLabels: { v1: 'Tabbed grid', v2: 'Carousel, three across', v3: 'Carousel' } },
  'product-grid': { variantLabels: { v1: 'Tabbed grid', v2: 'Featured + grid', v3: 'Numbered list', v4: 'One large + four', v5: 'Three across', v6: 'Numbered list + offer' } },
  'categories': { variantLabels: { v1: 'Square carousel', v2: 'Shortcut strip' } },
  'category-bento': { variantLabels: { v1: '3 + 2 tiles', v2: 'Mosaic (first tile large)' } },
  'offer-banner': { variantLabels: { v1: 'Strip' } },
  'coupon': { hide: ['coupons[].bgColor'] },
  'header': { hide: ['topbar[].phone', 'topbar[].email', 'topbar[].showSocials', 'topbar[].socialLinks'], keep: ['v1', 'v2'], variantLabels: { v1: 'Search row and category bar', v2: 'One row' } },
  'footer': { hide: ['paymentMethods[].icon'], variantLabels: { v1: 'Product lists', v2: 'Compact' } },
  // Theme tab: button settings no part of this theme reads (colours and corner radius drive every button).
  'buttons': { hide: ['appearance.buttons.primary[].height', 'appearance.buttons.primary[].paddingX', 'appearance.buttons.primary[].label', 'appearance.buttons.outline[].height', 'appearance.buttons.outline[].paddingX', 'appearance.buttons.outline[].label', 'appearance.buttons.outline[].hoverBg'] },
  // Delivery time is shown on product cards only by Prottoho.
  'store-info': { hide: ['deliveryEta'] },
}
